Hop.defineModule('highlight-search-close-slideshow', (root) => {
    const SLIDESHOW_EVENT = 'modal-slideshow:highlight-search';
    const HEADER_SEARCH_CLASSES = {
        opened: 'OPENED',
    };

    function onHighlightSearch() {
        root.classList.add(HEADER_SEARCH_CLASSES.opened);
    }

    Hop.events.on(SLIDESHOW_EVENT, onHighlightSearch);

    return function destroy() {
        Hop.events.off(SLIDESHOW_EVENT, onHighlightSearch);
    };
});
